<header class="header" [class.hidden]="isOnboardingRoute()">
  <nav class="navbar">
    <div class="custom-container">
      <div class="flex justify-between items-center bg-white pt-6 z-50 relative">
        <a class="navbar-logo mt-1" routerLink="/">
          <img class="w-[6rem] md:w-[11.3rem]" src="/images/logos/logo.svg" alt="">
        </a>

        <div class="navbar-desktop display-md-none">
          <app-nav-list [collapsible]="false" [show]="showNavbar()"></app-nav-list>
        </div>

        <div class="flex items-center navbar-actions">
          <div class="">
            <button type="button" class="header__btn" (click)="openAuth()">
              <img src="/images/icons/profile.svg" class="w-5 md:w-6 h-auto" alt="">
              <span>{{ 'personal_account' | translate }}</span>
            </button>
          </div>
          <lang-button/>

          @if (isCabinetRoute()){
            <div class="display-md-block">
              <button class="icon-btn-primary" (click)="expandNavbar()">
                @if (expandMainNavbar()) {
                  <img class="close-icon" src="/images/icons/close-black.svg" alt="">
                } @else {
                  <img class="menu-icon" src="/images/icons/option-black.svg" alt="">
                }
              </button>
            </div>
          }
        </div>
      </div>
      <div class="flex justify-between items-center">
        <div class="display-sm-block">
          <app-nav-list [collapsible]="false" [show]="!isCabinetRoute()"></app-nav-list>
        </div>
      </div>

      <div class="display-md-block">
        @if (isReferralCabinetRoute()) {
          <app-referral-cabinet-menu [show]="showCabinetMenu()" />
        } @else {
          <app-cabinet-menu-list [show]="showCabinetMenu()" />
        }
        <app-nav-list [collapsible]="true" [show]="showMainNav()" />
      </div>


    </div>
  </nav>
</header>
